import React from "react";
import { I18n } from ".";

type Props = { i18nKey: StringKey; children: any; values?: { [key: string]: any } };

const placeholderRegex = /<(\d+)>(.*?)<\/\1>/g;

function interpolate(string: string, children: any) {
  const childArray = Array.isArray(children) ? children : [children];

  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = placeholderRegex.exec(string)) !== null) {
    const [placeholder, index, innerText] = match;
    const textBefore = string.slice(lastIndex, match.index);

    if (textBefore) parts.push(textBefore);

    const childIndex = parseInt(index, 10) - 1;
    if (childArray[childIndex]) parts.push(React.cloneElement(childArray[childIndex], { key: childIndex }, innerText));

    lastIndex = match.index + placeholder.length;
  }

  if (lastIndex < string.length) parts.push(string.slice(lastIndex));
  return parts;
}

export default function Trans({ i18nKey, children, values }: Props) {
  const jsx = interpolate(I18n.t(i18nKey, { values }), children);
  return <>{jsx}</>;
}
